import Component from './component';
import languageSelector from '../languageSelector';

/**
 * LanguageSelector component
 */
export default class LanguageSelector extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }

    enable() {
        languageSelector.init();
    }
}
